import type { FaireProductEntity } from "../../entity_types/product";

export const p_zu8hk9gxhn: FaireProductEntity = {
  token: "p_zu8hk9gxhn",
  type: "product",
  name: "bough place cards",
  brandToken: "b_mmdanrh9jf",
  brandName: "emily lex studio",
  imageUrl:
    "https://cdn.faire.com/fastly/b58e1e4f3875eaaa8e2ce404861fb82c2497f87123b1d7e173b37e07e7a852cc.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/713adaadd0f985cebe10f7f5545d4cea0bab23bdc7b2a136fd6eebfc098c947f.jpeg",
    "https://cdn.faire.com/fastly/c8b8088f3096f4bdaf76d5a43cc2619a57b9cdff3e03b8507b559b1b7ead1df3.jpeg",
    "https://cdn.faire.com/fastly/202cc4883447cd13184772e29ba041a3e4571814cb87dd0a1d91d6097b19ac5b.jpeg",
    "https://cdn.faire.com/fastly/bd8993797ba829d33bd70a22b2564814fcce9dbb4ccc03fc6caf8b9f49e086ed.jpeg",
  ],
  priceDollars: 5,
  description:
    'Set a festive table for all your holiday gatherings with charming place cards for each guest. Christmas Bough illustration on the front with red and white stripes on the back.\n\n\nDetails:\n\n- set of eight place cards\n- blank space for name to be written\n- 2" x 3.5" when folded\n- Printed on 120lb superfine paper\n- Original watercolor artwork by Emily Lex\n',
  tags: [],
  msrpDollars: 10,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-14T07:14:46.888Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
